import { h } from '@stencil/core';
import { SVGOpts } from '../icons-opts';

export const CheckCircle = (opts?: SVGOpts) => (
  <svg class={opts?.class} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0C3.58065 0 0 3.6129 0 8C0 12.4194 3.58065 16 8 16C12.3871 16 16 12.4194 16 8C16 3.6129 12.3871 0 8 0ZM8 1.54839C11.5484 1.54839 14.4516 4.45161 14.4516 8C14.4516 11.5806 11.5484 14.4516 8 14.4516C4.41935 14.4516 1.54839 11.5806 1.54839 8C1.54839 4.45161 4.41935 1.54839 8 1.54839ZM12.5161 5.77419L11.7742 5.03226C11.6452 4.87097 11.3871 4.87097 11.2258 5.03226L6.67742 9.54839L4.74194 7.6129C4.58065 7.45161 4.35484 7.45161 4.19355 7.6129L3.45161 8.32258C3.32258 8.48387 3.32258 8.74193 3.45161 8.87097L6.3871 11.8387C6.54839 12 6.77419 12 6.93548 11.8387L12.5161 6.32258C12.6452 6.16129 12.6452 5.90323 12.5161 5.77419Z"
      fill="#0055FF"
    />
  </svg>
);
